


import React from "react";
import { useLanguage } from "../i18n/LanguageProvider";

export default function ShopPage() {
  const { t } = useLanguage();

  return (
    <div
      style={{
        width: "92%",
        margin: "18px auto 0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "18px",
      }}
    >
      <div
        style={{
          background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.10)",
          borderRadius: "20px",
          padding: "18px 16px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.22)",
        }}
      >
        <div
          style={{
            fontSize: "22px",
            fontWeight: "800",
            color: "#fff",
            marginBottom: "10px",
          }}
        >
          {t("shop.title")}
        </div>

        <div
          style={{
            color: "rgba(255,255,255,0.9)",
            fontSize: "15px",
            lineHeight: "1.5",
            marginBottom: "10px",
          }}
        >
          {t("shop.comingSoon")}
        </div>

        <div
          style={{
            color: "rgba(255,255,255,0.6)",
            fontSize: "14px",
          }}
        >
          {t("shop.moreInfo")}
        </div>
      </div>
    </div>
  );
}